import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../../hooks/useTheme";
import styles from "./MediaCard.module.scss";
import { getImageUri } from "../../utils/functions/getImageUri";

interface Props {
  imageUrl?: string;
  title: string;
  description?: string;
  to: string;
  badge?: string;
}

export const MediaCard = ({ imageUrl, title, description, to, badge }: Props) => {
  const { theme } = useTheme();

  return (
    <Link
      to={to}
      className={styles.card}
      style={{
        backgroundColor: theme.card,
        borderColor: theme.border,
      }}
    >
      {imageUrl && (
        <img
          className={styles.image}
          src={`${getImageUri()}${imageUrl}`}
          alt={title}
        />
      )}

      <div className={styles.content}>
        <h3 className={styles.title} style={{ color: theme.onCard }}>
          {title}
        </h3>

        {description && (
          <p
            className={styles.description}
            style={{ color: theme.textSecondary }}
          >
            {description}
          </p>
        )}

        {badge && (
          <span className={styles.badge} style={{ color: theme.danger }}>
            {badge}
          </span>
        )}
      </div>
    </Link>
  );
};